module.exports = __webpack_public_path__ + "img/approve-list8.2c07fc69.png";